/**
 * `POST /api/user/currency` — set seller payment currency on profile.
 *
 * @see app/api/user/currency/route.ts
 */

import { z } from "zod";
import { pinned } from "./pin";

export interface UserCurrencyUpdateRequest {
  currency: string;
}

export interface UserCurrencyUpdateResponse {
  currency: string;
}

export const UserCurrencyUpdateRequestSchema = pinned<UserCurrencyUpdateRequest>()(
  z.object({
    currency: z.string().length(3),
  }),
);

export const UserCurrencyUpdateResponseSchema = pinned<UserCurrencyUpdateResponse>()(
  z.object({
    currency: z.string().length(3),
  }),
);
